namespace e5 {
    export interface AbstractImageLoaderOptions extends AbstractLoaderOptions {

    }

    export abstract class AbstractImageLoader<Image extends HTMLElement, Options extends AbstractImageLoaderOptions> extends AbstractLoader<Image, Options>{
        private _image: HTMLImageElement;

        constructor(url: string, options: Options = null) {
            super(url, options);

            var img = document.createElement("img");
            if (Caps.isInternetExplorer) {
                img.style.position = "absolute";
                img.style.visibility = "hidden";
                img.style.pointerEvents = "none";
                img.style.display = "block";
                document.body.prepend(img);
            }

            img.onerror = (e) => {
                this.reject(e)
            }

            img.onload = async (e) => {
                if (typeof this.convert === "function") {
                    this.resolve(await this.convert(img));
                } else {
                    this.resolve(img as any);
                }
            }

            img.onprogress = (e: ProgressEvent) => {
                this._onProgress.dispatch(e.loaded, e.total, e);
            }

            img.src = url;

            this._image = img;
        }

        protected async convert?(img: HTMLImageElement): Promise<Image>;

        public cancel(reason: any = null): this {
            this._image.onerror = null;
            this._image.src = "";
            this._image.removeAttribute("src");
            super.cancel(reason);
            return this;
        }

        protected finish(): void {
            var img = this._image;
            if (Caps.isInternetExplorer) {
                img.removeAttribute("style");
            }
            img.style.pointerEvents = null;
            img.remove();
            img.onerror = null;
            img.onload = null;
            img.onprogress = null;
            this._image = null;

            super.finish();
        }
    }
}